import { HelpContent } from '../../../UI-Lib/Help-Tooltip';

export const LONG_RUNNING_PROCESS_PAGE_HELP: HelpContent[] = [
    {
        helpContentId: 'long-running-process-page.auto-refresh',
        tooltipText: 'When checked, the list will automatically refresh when any long-running process status changes.'
    }
];
